import BaseCommand from "@/models/api/commands/BaseCommand";

export class AddAttributeCommand extends BaseCommand {
  CommandName = "AddAttribute";
  Command: {
    AttributePrototypeId: number;
    Value: string;
    BookingItemTmpId: string;
  };
  constructor(
    sessionId: string,
    operationId: string,
    attributePrototypeId: number,
    value: string,
    bookingItemTmpId: string
  ) {
    super(sessionId, operationId);
    this.Command = { Value: value, AttributePrototypeId: attributePrototypeId, BookingItemTmpId: bookingItemTmpId };
  }
}
